// extracted by mini-css-extract-plugin
export default {"tab":"styles_tab__X9T5c","tabs":"styles_tabs__0ezIU","selected":"styles_selected__CQlLI","sticky":"styles_sticky__ONotM","mobilePadding":"styles_mobilePadding__SPfou"};